import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getDropdownTemplate(tipo_template_id?): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/template-resposta/dropdown/${tipo_template_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  traduzirTemplate(template_id, entidade_id): Observable<any> {
    const params: Record<string, string | number> = {};
    if (entidade_id !== undefined && entidade_id !== null && entidade_id !== '') {
      params.entidade_id = entidade_id;
    }
    this.httpOptions.params = params;
    return this.http.get(`${this.apiUrl}api/template-resposta/traducao/${template_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownComentarios() : Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/template-resposta/dropdown`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );

  }
  dropdownTemplateTipoResposta() : Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/template-resposta/dropdown-tipos`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
